<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت   کاتالوگ و بروشور</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp; کاتالوگ جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingCats" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.c_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.c_Id)" dark v-if="!item.c_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.c_Id)" dark v-else> فعال</v-btn>
                            </template>
                            
                            <template v-slot:[`item.c_ImageUrl`]="{ item }">
                                <v-btn target="_blank" :href="LogoUrl+`${item.c_ImageUrl}`" icon small><v-icon small>fas fa-eye</v-icon></v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New IG From Dialog-->
            <v-dialog fullscreen persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت کاتالوگ جدید</span>
                              <span v-else>ویرایش   &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="CatCreationDialog = false" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md4 lg4 xl4 style="padding:15px;padding-top:0px !important;border-left:1px solid rgb(200,200,200)"><!--Register New Cat From-->
                                    <div style="padding-top:23px;padding-bottom:5px;font-weight:bolder;font-size:17px">تنظیمات اصلی</div>
                                                                      
                                    <!-- <v-autocomplete :loading="isLoadingCatItems" v-model="galleryCategory" item-text="gC_Titles" item-value="gC_Id" :items="GalleryCatsItems" no-data-text="دسته بندی موجود نیست" color="#2a2d45" outlined dense label="انتخاب دسته بندی" ></v-autocomplete> -->
                                    
                                    <v-text-field color="#2a2d45" outlined dense v-model="GalleryTitle" label="عنوان " ></v-text-field>
                                   
                                    <v-text-field color="#2a2d45" outlined dense v-model="GallerySortField" label="ترتیب نمایش"></v-text-field>
                                    <f-up  :OldFile="Image" @RetunedFileName="Image = $event" Root="ELOGO" Folder="CONTENT" BtnTitle="عکس"></f-up>
                                    <file-upload :OldFile="FileAddress" @RetunedFileName="FileAddress = $event"  BtnTitle=" کاتالوگ"></file-upload>

                                    <v-btn v-if="inEditingItem" dark block color="green" :href="pathToFile">نمایش فایل</v-btn>
                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="GalleryStatus" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>
                                   
                                    <v-btn @click="registerGalleryChild" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                </v-flex>
                               
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <!-- <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp; -->
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<style scoped>
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');

const MSGHNDL = require('../../../constant/MessageHandler');
const FTYPES = require('../../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../../constant/setting/Default/AllowedFileSize');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
import imgeditor from '../../../components/media/editor.vue';
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
    name:"catalog",
   components: {
            Loading,
            JsonExcel
        },
    data:()=> ({
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        CatCreationDialog:false,
        galleryCategory:1,
        searchcategory:"",
        isLoadingCats:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            // {text:"دسته بندی ",value:"c_CatTitle",sortable:true,align:"right"},
            {text:"عنوان ",value:"c_Title",sortable:true,align:"right"},
            {text:"ترتیب نمایش",value:"c_SortField",sortable:true,align:"right"},
            {text:"عکس",value:"c_ImageUrl",sortable:true,align:"right"},
            {text:"وضعیت",value:"c_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        GalleryTitle:"",
        GallerySortField:"",
        GalleryStatus:"",
        originalItems:[],
        ALLOEWDIMGSIZE:{},
        LogoUrl:"",
        CatSeoModel:{},
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            // "دسته بندی":"c_CatTitle",
            "عنوان":"c_Title",
            "ترتیب نمایش":"c_SortField",
            "وضعیت":"c_Status",
            "عکس":"c_ImageUrl",
        },
        BrndDescription:"",
        GalleryCatsItems:[],
        isLoadingCatItems:true,
        Image:"",
        GalleryChildImgUrl:"",
        seo:"",
        SeoData:{},
        FileAddress:"",
        pathToFile:""
    }),
    async created()
    {
        let vm = this;
        vm.pathToFile = ApiUrl.CatalogFile;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadChilds();
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadChilds();
        }
    },
    methods:{
      
        ...mapActions([                  // Add this
        'setSeoForm'
        ]),
        LoadSeoFormData()
        {
            let vm = this;

            return vm.seo;
           
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.c_Id = id;
            await axios.post(ApiUrl.ActiveCatalog,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadChilds();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.c_Id = id;
            await axios.post(ApiUrl.DisableCatalog,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadChilds();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.GalleryTitle = "";
            vm.GallerySortField = "";
            vm.GalleryStatus = false;
            vm.BrndDescription = "";
            vm.SeoData = {
            title:"",
            url:"",
            keywords:"",
            image:"",
            description:"",
            othermeta:""
            };
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
        },
        editItem(item)
        {
            let vm = this; 
            vm.CatCreationDialog = true;
            // vm.galleryCategory = item.c_CatId;
            vm.GalleryTitle = item.c_Title;
            vm.GallerySortField = item.c_SortField;
            vm.GalleryStatus = item.c_Status;
            vm.GalleryChildImgUrl =vm.LogoUrl+ item.c_ImageUrl;
            vm.Image = item.c_ImageUrl;
            vm.pathToFile = ApiUrl.CatalogFile+item.c_FileUrl;
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
        },
        async loadChilds()
        {
            let vm = this;
            vm.isLoadingCats = true;
            await axios.post(ApiUrl.LoadCatalog+'/'+vm.LANG).then((res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
       
        async registerGalleryChild()
        {
            let vm = this;
            let Model = {};
            Model.C_CatId = vm.galleryCategory;
            Model.C_Title = vm.GalleryTitle;
            Model.C_SortField = parseInt(vm.GallerySortField);
            Model.C_Status = vm.GalleryStatus;
            Model.C_ImageUrl = vm.Image;
            Model.C_FileUrl = vm.FileAddress;
            Model.Lang = vm.LANG;
            let url = ApiUrl.AddCatalog;
            if(vm.inEditingItem)
            {
                Model.C_Id = vm.EditSelectedItem.c_Id;
                url = ApiUrl.updateCatalog;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadChilds();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        }
    }
}
</script>